import { useEffect, useRef } from 'react';

export function useInterval(callback, timeout) {
    const savedCallback = useRef<() => any>();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    });

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (timeout !== null) {
            let id = setInterval(tick, timeout);
            return () => clearInterval(id);
        }
    }, [timeout]);
}
